import { useState, useEffect } from 'react';

export const useDeviceType = () => {
  const [device, setDevice] = useState({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
  });

  useEffect(() => {
    const updateDevice = () => {
      const width = window.innerWidth;

      setDevice({
        isMobile: width <= 767,
        isTablet: width > 767 && width <= 1023,
        isDesktop: width > 1023,
      });
    };

    // Initial check
    updateDevice();

    // Listen to resize events
    window.addEventListener('resize', updateDevice);

    // Cleanup listener
    return () => window.removeEventListener('resize', updateDevice);
  }, []);

  return device;
};
